import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Icon-only theme toggle.  ``compact`` remains supported so legacy callers
 * (LoginPage) render an identical control.
 */
export default function ThemeToggle({ compact = true }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className="h-[38px] w-[38px] grid place-items-center rounded-[10px] ink-muted hover:ink hover:bg-foreground/[0.06] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
    >
      {isDark ? <Moon size={16} /> : <Sun size={16} />}
    </button>
  );
}
